import { BillInsertsNotifications } from '@sitecore/types/MyEnecoInvoice';

export const billInsertNotificationMap = (
  billInsertCode: string | undefined | null,
  billInsertsNotification: BillInsertsNotifications,
): [string, string] => {
  if (!billInsertCode || !billInsertsNotification) return ['', ''];

  const notificationMap: Record<string, keyof BillInsertsNotifications> = {
    '602': 'settlementZAndWDynamicNotification',
    '520': 'firstBillResNotification',
    '525': 'firstBillSohoNotification',
    '530': 'yearlyBillResNotification',
    '535': 'yearlyBillSohoNotification',
    '700': 'familyDiscountNotification',
    '118': 'settlementTooLateLightDelayNotification',
    '119': 'finalSettlementTooLateLightDelayNotification',
    '120': 'settlementTooLateHeavyDelayNotification',
    '121': 'finalSettlementTooLateHeavyDelayNotification',
    '123': 'billShockMediumNoDelayNotification',
    '223': 'billShockMediumNoDelayNotification',
    '124': 'billShockMediumLightDelayNotification',
    '127': 'billShockMediumHeavyDelayNotification',
    '128': 'billShockHighNoDelayNotification',
    '129': 'billShockHighLightDelayNotification',
    '229': 'billShockHighLightDelayNotification',
    '130': 'billShockHighHeavyDelayNotification',
    '230': 'billShockHighHeavyDelayNotification',
    '109': 'previousAdvanceSingleInsteadOfDualFuelNotification',
    '209': 'previousAdvanceSingleInsteadOfDualFuelNotification',
    '111': 'familyDiscountNotification',
    '125': 'settlementForOneEnergyIdenticalNotification',
    '126': 'settlementForOneEnergyIdenticalNotification',
    '225': 'settlementForOneEnergyIdenticalNotification',
    '226': 'settlementForOneEnergyIdenticalNotification',
    '140': 'invoiceResidentOwnerNotification',
    '240': 'invoiceResidentOwnerNotification',
    '161': 'allocationSoctarNotification',
    '170': 'estimatedMeterReadingsNotification',
    '395': 'updateMasterDataNotification',
    '310': 'interimSettlementMeterChangeNotification',
    '320': 'interimSettlementMeterChangeNotification',
    '190': 'advanceInvoicesTechnicalIssueNotification',
  };

  const notificationKey = notificationMap[billInsertCode];
  const notification = billInsertsNotification[notificationKey as keyof BillInsertsNotifications];

  return notification?.value ? [notification.value.title, notification.value.content] : ['', ''];
};
